import TextValueType from './TextValueType'
import ImageValueType from './ImageValueType'
import ProductSections from './ProductSections'

export default class Product {
  order: number
  productId: string
  clientCode: string
  copaymentType: string
  family: string
  productName: string
  productDescription: string
  reimbursement: number
  imagePath: string
  hiringMaxAge?: number
  highlights: ImageValueType[]
  coverages: TextValueType[]
  optionalCoverages: TextValueType[]
  copayments: TextValueType[]
  deficiencies: TextValueType[]
  sections: ProductSections
  ':type': string

  constructor(data: any) {
    this.order = data.order
    this.productId = data.productId
    this.clientCode = data.clientCode
    this.copaymentType = data.copaymentType
    this.family = data.family
    this.productName = data.productName
    this.productDescription = data.productDescription
    this.reimbursement = data.reimbursement
    this.imagePath = data.imagePath
    this.hiringMaxAge = data.hiringMaxAge
    this.highlights = data.highlights?.map((h: any) => new ImageValueType(h))
    this.coverages = data.coverages?.map((c: any) => new TextValueType(c))
    this.optionalCoverages = data.optionalCoverages?.map((oc: any) => new TextValueType(oc))
    this.copayments = data.copayments
    this.deficiencies = data.deficiencies?.map((d: any) => new TextValueType(d))
    this.sections = data.sections
    this[':type'] = data[':type']
  }
}
